import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Color } from '../../MobileView/ColorArray';
import { setProduct2d, setProduct2dBaseColor } from '../../../redux/actions/product2dActions';

export const useProductColors = () => {
    const dispatch = useDispatch()

    const product2d = useSelector((state: any) => state.product2d)
    const makFabric = useSelector((state: any) => state.makFabric)

    const products = useSelector(({ products }: any) => products);
    const { sizeColorMapping } = products || {}

    const [colors, setColors] = useState([])

    const [garmentC, setGarmentC] = useState(null as Color|null)

    useEffect(() => {
        if (sizeColorMapping && product2d) {
            setColors(sizeColorMapping[product2d.size] || [])
            setGarmentC({
                color: product2d.color,
                label: product2d.colorName
            })
        }

    }, [sizeColorMapping, product2d.size])

    useEffect(() => {
        const garmentColor = colors.find((item: any) => item.color === product2d.color);
        garmentColor && setGarmentC(garmentColor)
        makFabric && makFabric.setBaseColor(product2d.color)
    }, [product2d.color])

    const handleSelectColor = useCallback((color: Color) => {
        dispatch(setProduct2dBaseColor({...color}))

        setGarmentC({...color})

        const newSelection = products.skuArray.find((item: any) => {
            return (item.color ===color.color) && (item.size === product2d.size)
        })

        const selection = {
            ...product2d,
            variationSKU: newSelection.sku,
            price: newSelection.price,
            color: color.color
        }

        dispatch(setProduct2d(selection))


    },
        [dispatch, makFabric, products, product2d],
    )

    return{
        colors,
        selectedColor: garmentC,
        handleSelectColor
    }

}